import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { combinePaths } from "../models/flexible/utils";
import { anyNamedEntity } from "../utils/any-named-entity";
import { distinctBy } from "../utils/distinct-by";
import { getPathPrefix } from "../utils/get-path-prefix";
import { useScopeFields } from "./useScopeFields";
import { useScopes } from "./useScopes";
import { Brand } from "../models/generated/graphql";

export const useAvailableGenericNames = (fieldController: FlexFieldController, path: string) => {
	const [value] = useFieldValue(path);
	const [brandValues] = useFieldValue(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.BrandName));
	const brandNames: Array<string> = brandValues.length ? brandValues.map((brandValue: Brand) => brandValue.Name) : [];
	const { generics } = useScopeFields(fieldController.parent.context);
	const { selectedScopes, allScopes } = useScopes(fieldController.parent.context);

	if (!allScopes.length && generics.length) {
		return generics;
	}

	const selectableGenerics = selectedScopes
		.flatMap((scope) => scope.treatmentSets)
		.filter(
			(treatmentSet) =>
				!brandValues.length ||
				brandValues[0].Name === anyNamedEntity.Name ||
				treatmentSet.preparations.some((preparation) => brandNames.includes(preparation.BrandName)) ||
				treatmentSet.generic.preparations.some((preparation) => brandNames.includes(preparation.BrandName))
		)
		.map((treatmentSet) => treatmentSet.generic)
		.filter((generic) => value?.Name === generic.Name || generics.every((selectedGeneric) => selectedGeneric.Name !== generic.Name));

	return distinctBy(
		selectableGenerics.map((generic) => ({ Name: generic.Name, __typename: generic.__typename })),
		(generic) => generic.Name
	);
};
